import { i as OTelService, n as EXTENSION_ACTIVITY_EVENT, r as ExtensionActivitySnowplowTracker } from "./extension_activity_tracker-BO5QIfPu.mjs";
import { Injectable, createInterfaceId } from "@gitlab/needle";
import { ExponentialBackoffCircuitBreaker } from "@gitlab-org/core";
import { ConfigService } from "@gitlab-org/config";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { HEARTBEAT_ACTIVITY_KEY, UserPersistentStorage } from "@gitlab-org/persistent-storage";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { OTLPMetricExporter } from "@opentelemetry/exporter-metrics-otlp-http";
import { MeterProvider, PeriodicExportingMetricReader } from "@opentelemetry/sdk-metrics";
import { BatchSpanProcessor, NodeTracerProvider } from "@opentelemetry/sdk-trace-node";
import { Resource } from "@opentelemetry/resources";
import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";
import { ExportResultCode } from "@opentelemetry/core";
//#region src/extension_activity/daily_activity_tracker.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const ACTIVITY_CHECK_INTERVAL_MS = 60 * 1e3;
const MS_PER_DAY = 1440 * 60 * 1e3;
const DailyActivityTracker = createInterfaceId("DailyActivityTracker");
let _DefaultDailyActivity;
(class {
	static {
		[_DefaultDailyActivity, _initClass$1] = _applyDecs$1(this, [Injectable(DailyActivityTracker, [
			ExtensionActivitySnowplowTracker,
			UserPersistentStorage,
			Logger,
			ConfigService
		])], []).c;
	}
	#tracker;
	#storage;
	#logger;
	#isInitialized = false;
	#pendingSaveTimestamp;
	#lastActivity;
	#configService;
	#additionalContext = {};
	constructor(tracker, storage, logger, configService) {
		this.#tracker = tracker;
		this.#storage = storage;
		this.#logger = withPrefix(logger, "[DailyActivityTracker]");
		this.#configService = configService;
	}
	async initialize(context) {
		if (this.#isInitialized) return;
		if (context) this.#additionalContext = context;
		setInterval(() => {
			this.#checkAndSendActivity().catch((error) => {
				this.#logger.warn("Error during activity check", error);
			});
		}, ACTIVITY_CHECK_INTERVAL_MS);
		this.#isInitialized = true;
	}
	async #checkAndSendActivity() {
		if (!this.#tracker.isEnabled()) return;
		if (this.#pendingSaveTimestamp) {
			await this.#retrySavePendingTimestamp();
			return;
		}
		if (this.#lastActivity === void 0) this.#lastActivity = await this.#getLastActivityTimestamp();
		const now = Date.now();
		if (this.#shouldSendActivity(now, this.#lastActivity)) await this.#sendActivity(now);
	}
	#shouldSendActivity(now, lastActivity) {
		if (lastActivity === null) return true;
		return now - lastActivity >= MS_PER_DAY;
	}
	async #sendActivity(timestamp) {
		try {
			if (!this.#tracker.hasClientContext()) return;
			await this.#tracker.trackEvent(EXTENSION_ACTIVITY_EVENT.ActiveInstallation, {
				timestamp,
				...this.#additionalContext
			});
			try {
				await this.#saveLastActivityTimestamp(timestamp);
				this.#pendingSaveTimestamp = void 0;
			} catch (saveError) {
				this.#pendingSaveTimestamp = timestamp;
				this.#logger.warn("Failed to save activity timestamp, will retry on next check", saveError);
			}
		} catch (error) {
			this.#logger.warn("Failed to send activity event", error);
		}
	}
	async #retrySavePendingTimestamp() {
		if (!this.#pendingSaveTimestamp) return;
		try {
			await this.#saveLastActivityTimestamp(this.#pendingSaveTimestamp);
			this.#logger.info("Successfully saved pending activity timestamp");
			this.#pendingSaveTimestamp = void 0;
		} catch (error) {
			this.#logger.warn("Failed to retry save activity timestamp, will retry on next check", error);
		}
	}
	async #getLastActivityTimestamp() {
		try {
			const value = (await this.#storage.get(HEARTBEAT_ACTIVITY_KEY) || {})[this.#getActivityKey() || ""];
			return typeof value === "number" ? value : null;
		} catch (error) {
			this.#logger.warn("Failed to get last activity timestamp", error);
			return null;
		}
	}
	async #saveLastActivityTimestamp(timestamp) {
		const activityRecord = await this.#storage.get(HEARTBEAT_ACTIVITY_KEY) || {};
		const activityKey = this.#getActivityKey();
		if (!activityKey) {
			this.#logger.warn("No activity key available, cannot save activity timestamp");
			return;
		}
		if (!this.#configService.get("telemetry")?.ide?.version) this.#logger.warn("No IDE version available, cannot store activity by ide version");
		activityRecord[activityKey] = timestamp;
		await this.#storage.set(HEARTBEAT_ACTIVITY_KEY, activityRecord);
		this.#lastActivity = timestamp;
	}
	#getActivityKey() {
		const version = this.#configService.get("telemetry")?.ide?.version;
		const clientName = this.#configService.get("clientInfo.name");
		return version || clientName;
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/node/fallible_span_exporter.ts
var FallibleSpanExporter = class {
	#inner;
	#circuit;
	constructor(inner) {
		this.#inner = inner;
		this.#circuit = new ExponentialBackoffCircuitBreaker();
	}
	export(spans, resultCallback) {
		if (this.#circuit.isOpen()) {
			resultCallback({ code: ExportResultCode.SUCCESS });
			return;
		}
		this.#inner.export(spans, (result) => {
			if (result.code === ExportResultCode.FAILED) this.#circuit.error();
			else this.#circuit.success();
			resultCallback(result);
		});
	}
	forceFlush() {
		return this.#inner.forceFlush?.() ?? Promise.resolve();
	}
	shutdown() {
		return this.#inner.shutdown();
	}
};
//#endregion
//#region src/node/default_node_otel_service.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const DEFAULT_OTLP_BASE_URL = "https://9970.otel.gitlab-o11y.com:14318";
const DEFAULT_SERVICE_NAME = "gitlab-lsp";
const DEFAULT_SERVICE_PROJECT_ID = "46519181";
/**
* DI-managed Node.js OpenTelemetry implementation of {@link OTelService}.
*
* Provides the full Node.js OTel setup (a `NodeTracerProvider` and
* `MeterProvider` with OTLP HTTP exporters wrapped in circuit breakers for
* resilient export) and reads its configuration from {@link ConfigService},
* reacting to changes via `onConfigChange`. Register with
* `serviceCollection.addClass(DefaultNodeOTelService)`.
*
* The providers are constructed and held locally rather than registered as the
* global OTel provider, to avoid clashing with other libraries (e.g. Sentry)
* that may already own the process-global tracer/context/propagation APIs.
*
* For local testing instructions, see `docs/developer/opentelemetry.md`.
*/
let _DefaultNodeOTelServi;
(class {
	static {
		[_DefaultNodeOTelServi, _initClass] = _applyDecs(this, [Injectable(OTelService, [ConfigService, Logger])], []).c;
	}
	#tracerProvider;
	#meterProvider;
	#log;
	#enabled = false;
	#ide;
	#extension;
	#otlpBaseUrl = DEFAULT_OTLP_BASE_URL;
	#serviceName = DEFAULT_SERVICE_NAME;
	#serviceProjectId = DEFAULT_SERVICE_PROJECT_ID;
	constructor(configService, logger) {
		this.#log = withPrefix(logger, "[DefaultNodeOTelService]");
		const initial = configService.get("telemetry");
		if (initial) this.setConfig({
			enabled: initial.enabled,
			ide: initial.ide,
			extension: initial.extension
		});
		configService.onConfigChange((config) => {
			const { enabled, ide, extension } = config.telemetry ?? {};
			this.setConfig({
				enabled,
				ide,
				extension
			});
		});
	}
	setConfig(config) {
		if (config.ide) this.#ide = config.ide;
		if (config.extension) this.#extension = config.extension;
		if (config.otlpEndpoint) this.#otlpBaseUrl = config.otlpEndpoint;
		if (config.otelServiceName) this.#serviceName = config.otelServiceName;
		if (config.otelServiceProjectId) this.#serviceProjectId = config.otelServiceProjectId;
		if (typeof config.enabled !== "undefined" && this.#enabled !== config.enabled) {
			this.#enabled = config.enabled;
			if (config.enabled) this.initialize().catch((error) => {
				this.#log.error("Failed to initialize OpenTelemetry SDK on config change:", error);
			});
			else this.shutdown().catch((error) => {
				this.#log.error("Failed to shut down OpenTelemetry SDK on config change:", error);
			});
		}
	}
	isEnabled() {
		return this.#enabled;
	}
	async initialize() {
		if (this.#tracerProvider) {
			this.#log.warn("OpenTelemetry SDK already initialized, skipping");
			return;
		}
		if (!this.isEnabled()) {
			this.#log.debug("Telemetry disabled, skipping OTel initialization");
			return;
		}
		try {
			const resource = new Resource({
				[ATTR_SERVICE_NAME]: this.#serviceName,
				"gitlab.project.id": this.#serviceProjectId,
				"gitlab.project.name": this.#serviceName,
				os: process.platform,
				...this.#ide && {
					ide_name: this.#ide.name,
					ide_vendor: this.#ide.vendor,
					ide_version: this.#ide.version
				},
				...this.#extension && {
					extension_name: this.#extension.name,
					extension_version: this.#extension.version
				}
			});
			const traceExporter = new FallibleSpanExporter(new OTLPTraceExporter({
				url: `${this.#otlpBaseUrl}/v1/traces`,
				timeoutMillis: 5e3
			}));
			this.#tracerProvider = new NodeTracerProvider({
				resource,
				spanProcessors: [new BatchSpanProcessor(traceExporter, {
					maxQueueSize: 100,
					scheduledDelayMillis: 500,
					exportTimeoutMillis: 5e3,
					maxExportBatchSize: 50
				})]
			});
			const metricExporter = new OTLPMetricExporter({
				url: `${this.#otlpBaseUrl}/v1/metrics`,
				timeoutMillis: 5e3
			});
			this.#meterProvider = new MeterProvider({
				resource,
				readers: [new PeriodicExportingMetricReader({
					exporter: metricExporter,
					exportIntervalMillis: 6e4
				})]
			});
			this.#log.info(`OpenTelemetry SDK initialized (base URL: ${this.#otlpBaseUrl})`);
		} catch (error) {
			this.#log.error("Failed to initialize OpenTelemetry SDK:", error);
			throw error;
		}
	}
	getTracer(name) {
		if (!this.isEnabled()) return null;
		return this.#tracerProvider?.getTracer(name) ?? null;
	}
	getMeter(name) {
		if (!this.isEnabled()) return null;
		return this.#meterProvider?.getMeter(name) ?? null;
	}
	async shutdown() {
		if (!this.#tracerProvider && !this.#meterProvider) return;
		try {
			await Promise.all([this.#tracerProvider?.shutdown(), this.#meterProvider?.shutdown()]);
			this.#tracerProvider = void 0;
			this.#meterProvider = void 0;
			this.#log.debug("OpenTelemetry SDK shutdown complete");
		} catch (error) {
			this.#log.error("Error during OpenTelemetry SDK shutdown:", error);
		}
	}
	static {
		_initClass();
	}
});
//#endregion
export { DailyActivityTracker, _DefaultDailyActivity as DefaultDailyActivityTracker, _DefaultNodeOTelServi as DefaultNodeOTelService };

//# sourceMappingURL=node.mjs.map